var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.25L8 18.25V15.25H13C13.2652 15.25 13.5196 15.1446 13.7071 14.9571C13.8946 14.7696 14 14.5152 14 14.25V12.664C14 12.138 13.786 11.622 13.414 11.25L12 9.836V6.25C12.2652 6.25 12.5196 6.14464 12.7071 5.95711C12.8946 5.76957 13 5.51522 13 5.25V2.25C13 1.147 12.103 0.25 11 0.25H3C1.897 0.25 1 1.147 1 2.25V5.25C1 5.51522 1.10536 5.76957 1.29289 5.95711C1.48043 6.14464 1.73478 6.25 2 6.25V9.836L0.586 11.25C0.211827 11.6256 0.00120523 12.1338 0 12.664V14.25C0 14.5152 0.105357 14.7696 0.292893 14.9571C0.48043 15.1446 0.734784 15.25 1 15.25H6V18.25L7 20.25ZM3 2.25H11V4.25H3V2.25ZM2 12.664L3.707 10.957C3.80004 10.8643 3.87383 10.7541 3.92412 10.6328C3.9744 10.5114 4.00019 10.3813 4 10.25V6.25H10V10.25C10 10.516 10.105 10.77 10.293 10.957L12 12.664V13.25H2V12.664Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2bef5fd835cbf68878675e9e0afa7719.svg";
export { ForwardRef as ReactComponent };